import { AICredits } from "@/types/ai-assistant"

export type AIAssistantState = {
  conversationActiveId: string | null
  conversations: Array<any>
  credits: AICredits | null
  creditsPending: boolean
  getConversationsPending: boolean
  getConversationMessagesPending: boolean
  isPaneOpened: boolean
  postPromptPending: boolean
}

export const state: AIAssistantState = {
  conversationActiveId: null,
  conversations: [],
  credits: null,
  creditsPending: false,
  getConversationsPending: false,
  getConversationMessagesPending: false,
  isPaneOpened: false,
  postPromptPending: false,
}